module.exports = __webpack_public_path__ + "img/barcelona_toda_la_ciudad.33d8fa20.jpg";